import { Tag } from "./Tag"
import { ColumnType } from "../components/PhasePlan/Column"
import { Point } from "../modules/ui.reducer"

export interface SelectedTag {
    tagCardType?: TagType
    tagType?: TagType,
    position: Point
}

export enum  TagType {
    PhasePlan= 'PhasePlanTagType',
    Lookahead='LookaheadTagType',
    Constraint='ConstraintTagType'
}

export const isPhaseTag = (tag:Tag, type: ColumnType) => {
    return type === ColumnType.PhasePlan && tag.tagCardType === TagType.PhasePlan
}

export const isLookaheadTag = (tag:Tag, type: ColumnType) => {
    return type === ColumnType.Lookahead && tag.tagCardType === TagType.Lookahead
}

export const isConstraintTag = (tag:Tag, type: ColumnType) => {
    return tag.tagCardType === TagType.Constraint
}


// WEBPACK FOOTER //
// ./src/models/ TagType.ts